import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { hasValue } from '../common-functions';


@Injectable({
    providedIn: 'root'
})

export class LogService {
    //const data: UserData = await this.auth.getTokens();

    private readonly userFullNameSubject = new BehaviorSubject<string>('');
    userFullName$ = this.userFullNameSubject.asObservable();
    private readonly userRoleNameSubject = new BehaviorSubject<string>('');
    userRoleName$ = this.userRoleNameSubject.asObservable();
    constructor() {

       // this.gettoken();
    }

    setUserFullName(fullName: string) {
        //localStorage.setItem('userFullName', fullName);
        this.userFullNameSubject.next(fullName);
    }
    getUserFullName(): Observable<string> {
        return this.userFullName$;
    }
    setUserRoleName(roleName: string) {
        // localStorage.setItem('userRoleName', roleName);
        this.userRoleNameSubject.next(roleName);
    }
    
    getUserRoleName(): Observable<string> {

        return this.userRoleName$;
    }


}